module.exports = __webpack_public_path__ + "static/media/vod_heart.a0b594f7.svg";